import { Action } from "../../../actions/actions";
import { SubsidiariesActionTypes } from "../actions/actionTypes";
import { Subsidiary } from "../../halls/types/subsidiaries";

export function subsidiariesList(state: Subsidiary[] = [], action: Action) {
    switch (action.type) {
        case SubsidiariesActionTypes.GET_SUBSIDIARIES_SUCCESS:
            return action.payload.subsidiaries.results;
        default:
            return state;
    }
}

export function subsidiariesLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case SubsidiariesActionTypes.GET_SUBSIDIARIES:
            return true;
        case SubsidiariesActionTypes.GET_SUBSIDIARIES_SUCCESS:
        case SubsidiariesActionTypes.GET_SUBSIDIARIES_FAIL:
            return false;
        default:
            return state;
    }
}

export function subsidiaryEditing(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case SubsidiariesActionTypes.EDIT_SUBSIDIARY:
            return true;
        case SubsidiariesActionTypes.EDIT_SUBSIDIARY_END:
        case SubsidiariesActionTypes.SAVE_SUBSIDIARY_LOGO_SUCCESS:
            return false;
        default:
            return state;
    }
}
